module.exports = __webpack_public_path__ + "img/analytics.104ac8ec.svg";